import { IconButton, Text } from '@/shared/ui/primitives';
import { X } from 'lucide-react';
import type { FC, ReactNode } from 'react';
import styles from './ModalTopBar.module.css';

interface ModalTopBarProps {
  title: ReactNode;
  onCancel?: () => void;
  cancelTestId?: string;
  cancelDisabled?: boolean;
  testId?: string;
}

export const ModalTopBar: FC<ModalTopBarProps> = ({
  title,
  onCancel,
  cancelTestId,
  cancelDisabled,
  testId,
}) => (
  <div className={styles.bar} data-testid={testId}>
    <Text variant="title" as="h2" weight="medium" className={styles.title}>
      {title}
    </Text>
    {onCancel && (
      <IconButton
        variant="ghost"
        aria-label="Close"
        className={styles.close}
        onClick={onCancel}
        disabled={cancelDisabled}
        data-testid={cancelTestId}
      >
        <X size={20} aria-hidden="true" />
      </IconButton>
    )}
  </div>
);
